<template>
  <div class="event-level">
    <Card style="padding-bottom: 40px">
      <Button @click="addEventLevel" type="primary">添加</Button>
      <Table
          :loading="eventLevelLoading"
          :columns="columns"
          :data="data"
          :border="true"
          :highlight-current-row="true"
          style="margin-top: 10px"
      >
        <template #action="{ row, index }">
          <el-button size="small" type="text" @click="getEventLeveById(row)">编辑</el-button>
          <el-button size="small" type="text" @click="deleteEventLevel(row)">删除</el-button>
        </template>
      </Table>
    </Card>
    <Modal v-model="eventLevelModal"
           :title="isEdit ? '修改' : '添加'"
    >
      <Form :model="eventLevelFrom" :rules="eventLevelRules" :label-width="100" ref="eventLevelFrom">
        <FormItem label="事件等级" prop="name">
          <Input v-model="eventLevelFrom.name"></Input>
        </FormItem>
      </Form>
      <template slot="footer">
        <Button @click="eventLevelModal = false">取消</Button>
        <Button v-if="!isEdit" type="primary" :loading="addLoading" @click="addLevel">确定</Button>
        <Button v-else type="primary" :loading="addLoading" @click="editLevel">修改</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "eventLevel",
  data() {
    return {
      eventLevelModal: false,
      eventLevelLoading: false,
      addLoading: false,
      isEdit: false,
      columns: [
        {
          title: 'id',
          key: 'id',
          align: 'center',
        },
        {
          title: '事件等级',
          key: 'name',
          align: 'center',
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
        }
      ],
      data: [],
      eventLevelFrom: {
        name: '',
      },
      eventLevelRules: {
        name: [
          { required: true, message: '请输入事件等级', trigger: 'blur' }
        ],
      },
    }
  },
  mounted() {
    this.getEventLevel()
  },
  methods: {
    addLevel() {
      this.$refs.eventLevelFrom.validate((valid) => {
        if (valid) {
          this.addLoading = true
          this.$http.post('/api/eventLevels', this.eventLevelFrom).then(res => {
            this.addLoading = false
            this.eventLevelModal = false
            this.$Message.success('添加成功')
            this.getEventLevel()
          })
        } else {
          return false
        }
      })
    },
    getEventLeveById(row) {
      let id = row.id
      this.$http.get(`/api/eventLevels/${ id }`).then(res => {
        if (res.status === 200) {
          this.isEdit = true
          this.eventLevelFrom = res.data
          this.eventLevelModal = true
        } else {
          this.$Message.error('获取数据失败')
        }
      })
    },
    editLevel() {
      this.$refs.eventLevelFrom.validate((valid) => {
        if (valid) {
          this.addLoading = true
          let request = {
            ...this.eventLevelFrom
          }
          this.$http.put(`/api/eventLevels`, request).then(res => {
            if (res.status === 200) {
              this.addLoading = false
              this.eventLevelModal = false
              this.$Message.success('修改成功')
              this.getEventLevel()
            } else {
              this.$Message.error('修改失败')
            }
          })
        } else {
          return false
        }
      })
    },
    addEventLevel() {
      this.eventLevelModal = true
      this.isEdit = false
      this.eventLevelFrom = {}
    },
    getEventLevel() {
      this.$http.get('/api/eventLevels').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.data = res.data.data
        }
      })
    },
    deleteEventLevel(row){
      this.$http.delete(`/api/eventLevels/${row.id}`).then(res => {
        console.log(res)
        this.getEventLevel()
      })
    }
  }
}
</script>

<style scoped>

</style>
